var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaywallSaveDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 160,
    viewBox: "0 0 180 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1985_23486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.365 29.1108C168.786 26.3365 167.764 23.6775 167.685 20.817C163.104 20.3105 158.866 20.1752 154.242 20.1857C149.41 20.1857 141.85 18.7918 137.197 17.5337C103.5 16.5 107.629 20.0372 92.8559 20.4644C84.9917 20.7001 77.1034 18.6396 69.2829 19.6566C68.9293 17.7074 68.4299 8.70287 66.536 8C62.4592 8.54887 56.5555 8.34991 52.4491 8C48.7387 8 45.1744 9.83234 41.4623 9.7034C35.8316 9.51565 31.7771 9.27125 26.1948 8.5923C21.0663 9.03868 14.7143 9.31576 10 8C11.2143 17.1124 13.821 26.6081 10 35.6117C10.3853 39.8708 13.106 51.7207 13.5 56C14.6954 69.0473 11.3982 75.7523 10.1487 88.7379C10.1487 98.7928 13.5 101.5 10.6147 117.596C10.4878 127.552 11.3039 137.609 12.1 147.531C37.4533 144.398 44.6165 151.511 66.9317 148C79.9161 145.957 95.547 148.056 100.233 148.816C104.865 147.783 113.546 147.027 118.035 148.969C123.203 148.325 136.132 146.656 141.342 146.773C152.978 147.013 156.659 147.065 168.3 147.937C169.259 136.898 164.5 127.5 167.331 114.5C169.181 106 164.824 94.0543 167.331 84C170.695 70.5 165.167 67.5206 167.568 53.1267C168.889 45.2807 171.093 37.07 169.365 29.1108Z",
    fill: "#CCEEFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1985_23486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 49L72.2174 49.0001C70.5684 49.0001 68.987 49.6619 67.821 50.8399C66.655 52.0179 66 53.6156 66 55.2815V106.719C66 108.384 66.655 109.982 67.821 111.16C68.987 112.338 70.5684 113 72.2174 113H107.783C109.432 113 111.013 112.338 112.179 111.16C113.345 109.982 114 108.384 114 106.719V63L100 49Z",
    fill: "#02AAFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100 49V60C100 61.6569 101.343 63 103 63H114",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1985_23486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.61893 50.7841C9.23015 47.9342 10.8323 45.4377 12.1032 44.1882C13.5932 42.7267 15.0443 41.4417 17.3737 40.8973C20.1482 40.2536 22.1275 40.6251 24.797 41.5164C26.7794 42.1794 28.9029 43.2808 30.2003 44.0219C30.5876 44.2409 30.9749 44.4599 31.3622 44.6788C32.6662 45.4084 34.7047 46.6601 36.2949 48.0168C38.435 49.8446 39.7738 51.3491 40.6494 54.064C41.3839 56.3406 41.031 58.2466 40.547 60.2767C40.1373 62.0132 38.8242 64.6731 37.2163 67.5172L37.213 67.523L37.2098 67.5288C35.6018 70.3729 33.9997 72.8694 32.7287 74.119C31.2388 75.5805 29.7876 76.8655 27.4583 77.4099C24.6805 78.0593 22.7012 77.6879 20.0317 76.7966C17.7218 76.0247 15.2281 74.6606 14.0684 73.9592L14.0503 73.9642L14.0453 73.9461C12.8406 73.3108 10.3893 71.8716 8.53957 70.2994C6.3995 68.4716 5.06071 66.9671 4.18504 64.2522C3.45059 61.9756 3.80344 60.0697 4.2875 58.0395C4.69136 56.2997 6.00772 53.634 7.61893 50.7841Z",
    fill: "#03D3D3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.107 61.5495C10.3267 61.6737 10.5994 61.6906 10.8271 61.5981C12.6012 60.8619 14.1303 60.3837 15.8249 60.4492C17.4008 60.5087 19.1132 61.042 21.1692 62.1281L19.1429 65.7121C18.9207 66.1052 19.0614 66.612 19.4544 66.8342C19.6394 66.9388 19.8521 66.9675 20.0627 66.9187L32.248 63.8374C32.6907 63.7292 32.9547 63.2758 32.8464 62.8331C32.8413 62.815 32.8413 62.815 32.8363 62.7969L29.194 50.7674C29.0586 50.3323 28.6011 50.0889 28.1603 50.2211C27.9579 50.2821 27.7872 50.4221 27.6827 50.6071L25.64 54.22C22.2254 52.4879 19.0403 52.3196 16.1646 53.7224C13.7862 54.8798 11.646 57.1408 9.78639 60.43C9.57321 60.8206 9.71391 61.3273 10.107 61.5495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1985_23486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.986 33.7705C171.375 30.9206 169.773 28.4241 168.502 27.1745C167.012 25.713 165.561 24.428 163.232 23.8836C160.457 23.2399 158.478 23.6114 155.808 24.5027C153.826 25.1657 151.702 26.2671 150.405 27.0083C150.018 27.2272 149.63 27.4462 149.243 27.6652C147.939 28.3947 145.9 29.6464 144.31 31.0031C142.17 32.8309 140.831 34.3354 139.956 37.0504C139.221 39.3269 139.574 41.2329 140.058 43.263C140.468 44.9995 141.781 47.6594 143.389 50.5036L143.392 50.5094L143.395 50.5151C145.003 53.3593 146.606 55.8558 147.877 57.1053C149.366 58.5668 150.818 59.8518 153.147 60.3962C155.925 61.0457 157.904 60.6742 160.574 59.7829C162.883 59.011 165.377 57.6469 166.537 56.9455L166.555 56.9505L166.56 56.9324C167.765 56.2971 170.216 54.8579 172.066 53.2857C174.206 51.4579 175.545 49.9535 176.42 47.2385C177.155 44.9619 176.802 43.056 176.318 41.0259C175.914 39.2861 174.598 36.6204 172.986 33.7705Z",
    fill: "#A279F2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.498 44.5359C170.279 44.6601 170.006 44.6769 169.778 44.5845C168.004 43.8482 166.475 43.37 164.78 43.4356C163.204 43.4951 161.492 44.0284 159.436 45.1144L161.462 48.6985C161.685 49.0916 161.544 49.5983 161.151 49.8205C160.966 49.9251 160.753 49.9538 160.543 49.905L148.357 46.8238C147.915 46.7155 147.651 46.2621 147.759 45.8194C147.764 45.8013 147.764 45.8013 147.769 45.7832L151.411 33.7537C151.547 33.3186 152.004 33.0752 152.445 33.2074C152.647 33.2684 152.818 33.4084 152.923 33.5934L154.965 37.2064C158.38 35.4742 161.565 35.306 164.441 36.7087C166.819 37.8662 168.959 40.1271 170.819 43.4163C171.032 43.8069 170.891 44.3136 170.498 44.5359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1985_23486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.486 146.217C147.05 144.181 149.266 142.21 150.303 140.759C151.514 139.06 152.557 137.426 152.732 135.041C152.936 132.2 152.26 130.302 150.964 127.804C150 125.95 148.581 124.024 147.647 122.857C147.371 122.509 147.094 122.161 146.817 121.812C145.894 120.638 144.34 118.819 142.752 117.46C140.613 115.631 138.918 114.543 136.1 114.101C133.737 113.73 131.909 114.375 129.979 115.17C128.327 115.845 125.905 117.556 123.346 119.588L123.341 119.592L123.335 119.596C120.776 121.628 118.56 123.599 117.524 125.049C116.312 126.749 115.269 128.382 115.094 130.768C114.886 133.613 115.561 135.51 116.857 138.008C117.98 140.17 119.716 142.421 120.589 143.457L120.587 143.475L120.606 143.478C121.421 144.569 123.224 146.766 125.066 148.348C127.205 150.177 128.899 151.265 131.717 151.707C134.081 152.078 135.908 151.432 137.838 150.638C139.494 149.968 141.922 148.252 144.486 146.217Z",
    fill: "#FFAA00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.464 145.436C133.307 145.238 133.248 144.972 133.304 144.732C133.755 142.865 133.989 141.28 133.66 139.617C133.356 138.069 132.562 136.461 131.169 134.599L127.945 137.159C127.591 137.44 127.069 137.38 126.788 137.026C126.656 136.86 126.594 136.654 126.61 136.439L127.755 123.922C127.793 123.468 128.199 123.136 128.654 123.174C128.672 123.177 128.672 123.177 128.691 123.179L141.141 124.902C141.592 124.968 141.904 125.382 141.842 125.838C141.813 126.048 141.701 126.238 141.535 126.37L138.284 128.951C140.527 132.054 141.19 135.174 140.252 138.233C139.479 140.763 137.58 143.229 134.62 145.578C134.268 145.85 133.745 145.79 133.464 145.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1985_23486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6802 14.4416C77.7374 13.3888 79.6519 12.5407 80.8865 12.2985C82.3325 12.0166 83.687 11.8237 85.2711 12.4084C87.156 13.1077 88.1779 14.096 89.4042 15.6589C90.3145 16.8202 91.1375 18.2946 91.6138 19.2356C91.7569 19.5152 91.9 19.7948 92.0431 20.0744C92.5277 21.0111 93.2423 22.5411 93.6518 23.9586C94.2021 25.8675 94.4061 27.2744 93.8666 29.2144C93.4144 30.8412 92.4656 31.8271 91.3912 32.835C90.4747 33.6989 88.6671 34.7557 86.614 35.8064L86.6099 35.8085L86.6057 35.8106C84.5527 36.8613 82.6382 37.7094 81.4036 37.9516C79.9576 38.2335 78.6031 38.4265 77.019 37.8417C75.1299 37.1446 74.1081 36.1563 72.8817 34.5934C71.8208 33.2406 70.8818 31.4675 70.4712 30.6034L70.4586 30.5993L70.4626 30.5867C69.9998 29.7441 69.115 27.9432 68.6363 26.2978C68.0859 24.389 67.882 22.9821 68.4214 21.0421C68.8737 19.4152 69.8225 18.4294 70.8969 17.4214C71.8112 16.5533 73.6231 15.4944 75.6802 14.4416Z",
    fill: "#95DB0A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.9611 21.7517C73.0423 21.9103 73.1964 22.0262 73.3665 22.0603C74.6981 22.3162 75.7848 22.6288 76.7578 23.3262C77.6632 23.9739 78.4649 24.9538 79.254 26.3929L76.6669 27.7169C76.3831 27.8621 76.269 28.2154 76.4143 28.4991C76.4826 28.6327 76.5967 28.7322 76.7398 28.7854L85.1171 31.7069C85.42 31.8151 85.7518 31.6506 85.8601 31.3477C85.8642 31.3351 85.8642 31.3351 85.8683 31.3225L88.3986 22.8188C88.4879 22.5098 88.313 22.1886 88.0019 22.0951C87.8589 22.0524 87.7039 22.0685 87.5704 22.1368L84.9624 23.4715C83.6239 21.1235 81.8126 19.7862 79.573 19.4948C77.7217 19.2522 75.5818 19.7524 73.2075 20.9675C72.93 21.1147 72.8159 21.468 72.9611 21.7517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1985_23486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8424 148.829C30.1352 147.271 28.6696 145.776 28.01 144.705C27.239 143.449 26.5833 142.248 26.5755 140.56C26.5695 138.549 27.1369 137.246 28.1706 135.549C28.939 134.29 30.0312 133.002 30.7455 132.226C30.9572 131.994 31.1688 131.762 31.3805 131.53C32.0879 130.748 33.2702 129.542 34.4541 128.661C36.0488 127.477 37.2949 126.792 39.3009 126.617C40.9831 126.471 42.239 127.014 43.5597 127.666C44.69 128.222 46.3135 129.544 48.0173 131.098L48.0208 131.102L48.0242 131.105C49.728 132.659 51.1936 134.155 51.8532 135.226C52.6242 136.481 53.2799 137.682 53.2877 139.371C53.2971 141.384 52.7298 142.688 51.6961 144.384C50.8012 145.852 49.4699 147.353 48.8046 148.041L48.8052 148.054L48.792 148.055C48.1651 148.783 46.7888 150.243 45.4157 151.269C43.821 152.453 42.5749 153.138 40.5689 153.313C38.8867 153.46 37.6308 152.917 36.3102 152.264C35.1766 151.712 33.5497 150.386 31.8424 148.829Z",
    fill: "#FF4369"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.6417 148.812C39.7618 148.68 39.8163 148.496 39.7886 148.324C39.5613 146.988 39.4731 145.86 39.7851 144.704C40.0742 143.629 40.7108 142.535 41.7819 141.291L43.9289 143.25C44.1644 143.465 44.5353 143.448 44.7501 143.212C44.8512 143.102 44.9044 142.96 44.904 142.807L44.7028 133.937C44.698 133.616 44.4276 133.363 44.1059 133.367C44.0927 133.368 44.0927 133.368 44.0794 133.369L35.2284 133.981C34.9077 134.005 34.6682 134.282 34.6897 134.606C34.6999 134.755 34.7693 134.894 34.8801 134.995L37.0445 136.97C35.3148 139.047 34.6975 141.212 35.2099 143.411C35.6317 145.23 36.8504 147.059 38.8209 148.856C39.0561 149.065 39.4269 149.048 39.6417 148.812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1985_23486",
    x: 56,
    y: 48,
    width: 68,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.666667 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1985_23486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1985_23486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1985_23486",
    x: -1.23584,
    y: 39.5732,
    width: 47.3062,
    height: 47.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0117647 0 0 0 0 0.827451 0 0 0 0 0.827451 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1985_23486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1985_23486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1985_23486",
    x: 134.535,
    y: 22.5596,
    width: 47.3062,
    height: 47.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.635294 0 0 0 0 0.47451 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1985_23486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1985_23486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1985_23486",
    x: 110.057,
    y: 112.993,
    width: 47.7112,
    height: 47.8213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.666667 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1985_23486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1985_23486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1985_23486",
    x: 63.1055,
    y: 11.0278,
    width: 36.0771,
    height: 36.1943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.858824 0 0 0 0 0.0392157 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1985_23486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1985_23486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1985_23486",
    x: 21.5754,
    y: 125.593,
    width: 36.7124,
    height: 36.7437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.262745 0 0 0 0 0.411765 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1985_23486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1985_23486",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1985_23486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 160,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaywallSaveDocument);
export default __webpack_public_path__ + "static/media/paywall-save-document.58bf22b6d479d6622641e8b9ee38f59a.svg";
export { ForwardRef as ReactComponent };